import React, { useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import Translator, { __ } from "services/Translator";

const SortingDropdown = (props) => {
  // Get initial sorting from localStorage or use "Default" as default
  const getInitialSorting = () => {
    const saved = localStorage.getItem("gameSorting");
    return saved || "Default";
  };

  const [selectedSorting, setSelectedSorting] = useState(getInitialSorting);

  const sortingOptions = ["Default", "Most Popular", "Newest First", "A-Z Sorting", "Z-A Sorting"];

  const handleSortingChange = (sortingOption) => {
    setSelectedSorting(sortingOption);
    // Save to localStorage for persistence
    localStorage.setItem("gameSorting", sortingOption);

    if (props.onSortingChange) {
      props.onSortingChange(sortingOption);
    }
  };

  useEffect(() => {
    // If parent provides a default sorting, use it and save to localStorage
    if (props.defaultSorting && props.defaultSorting !== selectedSorting) {
      setSelectedSorting(props.defaultSorting);
      localStorage.setItem("gameSorting", props.defaultSorting);
    }
  }, [props.defaultSorting]);

  return (
    <>
      <Dropdown className="gameSortingDropdown">
        <Dropdown.Toggle className="sortingBtn" variant="success" id="dropdown-sorting">
          {selectedSorting}
        </Dropdown.Toggle>

        <Dropdown.Menu className="sortingLists">
          {sortingOptions.map((option, index) => (
            <div key={index}>
              <label htmlFor={`sorting-${index}`}>
                <input
                  defaultChecked={selectedSorting === option}
                  id={`sorting-${index}`}
                  type="radio"
                  name="sorting"
                  onChange={() => handleSortingChange(option)}
                />
                <div className="radioDesign"></div>
                <div className="sortingText">{__(option)}</div>
              </label>
            </div>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default SortingDropdown;
